import {
    Dialog,
    Dropdown,
    IconButton,
    Menu,
    MenuItemProps,
    Metadata,
    useListGraphqlQuery,
    useTranslationRoute,
    useTranslations,
    useUrlParamsValueToString,
} from "@bsm/component";
import { TFile } from "@bsm/graphql";
import { useState } from "react";
import { useDeleteSignatoryMutation } from "../hooks/useDeleteSignatoryMutation";
import { useNavigate } from "react-router-dom";
import { useLineMenu } from "../hooks/useLineMenu";
import { SIGNATORY_LIST_ID } from "../container/InvoiceListViewerSignatoriesContainer";

export const SignatoryListItem = ({
    id,
    name,
    fonction,
    signature,
}: SignatoryListItemProps) => {

    const [
        FUNCTION
    ] = useTranslations(keys)

    const [wantToDeleteSignatory, setWantToDeleteSignatory] = useState(false);
    const [menuState, setMenuState] = useState<{
        anchorEl: HTMLElement | null;
        id: number | null;
    }>({
        anchorEl: null,
        id: null,
    });
    const mutation = useDeleteSignatoryMutation();
    const navigate = useNavigate();
    const urlParams = useUrlParamsValueToString();
    const tr = useTranslationRoute();
    const { invalidateQuery } = useListGraphqlQuery(SIGNATORY_LIST_ID);

    const handleOpenMenu = (
        event: React.MouseEvent<HTMLButtonElement>,
        id: number
    ) => {
        setMenuState({ anchorEl: event.currentTarget, id });
    };
    const handleCloseMenu = () => {
        setMenuState((prevState) => ({ ...prevState, anchorEl: null }));
    };
    const menuEllipsisItems = useLineMenu();

    const handleMenuClick = (menu: MenuItemProps) => {
        if (menu.ke === "edit") {
            navigate(`${id}/edit?${urlParams}`);
        }

        if (menu.ke === "delete") {
            setWantToDeleteSignatory(true);
        }
        handleCloseMenu();
    };
    const deleteSignatory = () => {
        mutation.mutate({ ids: [id] }, {
            onSuccess: () => {
                invalidateQuery();
                setWantToDeleteSignatory(false);
        }});
    };

    return (
        <>
            <div className="flex items-center justify-between w-full pt-2 pb-4 border-default border-b">
                <div  onClick={() => navigate(`${id}?${urlParams}`)} className="flex flex-col gap-2 cursor-pointer">
                    <h3 className="font-bold text-base sm:text-lg">{name}</h3>
                    <Metadata label="Position"  value={fonction} /> 
                </div>
                <IconButton
                    icon={"fa-ellipsis"}
                    onClick={(e) => handleOpenMenu(e, id)}
                />
                {menuState.id === id && (
                    <Dropdown
                        anchorEl={menuState.anchorEl}
                        arrow
                        placement="bottom-end"
                        onClose={handleCloseMenu}
                    >
                        <Menu
                            items={menuEllipsisItems}
                            onClick={handleMenuClick}
                        />
                    </Dropdown>
                )}
            </div>

            <Dialog
                open={wantToDeleteSignatory}
                confirmation
                title={'Delete Signatory'}
                message="Are you sure you want to delete this signatory?"
                onConfirm={deleteSignatory}
                btnOk={{ label: 'Confirm', isSubmit: mutation.isLoading }}
                btnCancel={{ label: 'Cancel' }}
                onClose={() => {
                    setWantToDeleteSignatory(false);
                }}
            />
        </>
    );
};

const keys = [
    "std_function"
];

type SignatoryListItemProps = {
    id: number;
    name: string;
    fonction: string;
    signature: TFile;
};
